import axios from "axios";
import { clearToken } from "../utils/manageStore";
const BASE_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    "Content-type": "application/json",
  }
});



apiClient.interceptors.request.use((config) => {
  const accesToken = localStorage.getItem("token")

  if (accesToken) {
    config.headers.Authorization = `Bearer ${accesToken}`
  }
  return config;
},
  (error) => {
    return Promise.reject(error)
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      clearToken()
    }
    return Promise.reject(error);
  }
);

export async function get(path) {
  try {

    const response = await apiClient.get(path);
    return response;
  } catch (error) {
    return error;
  }
}

export async function put(path, data, contentType='json') {
  try {
    let headers = {};
    headers['Content-Type'] = 'application/json';
    if (contentType != 'json') {      
      headers['Content-Type'] = 'multipart/form-data'; // FormData automatically sets this
    } 
    const response = await apiClient.put(path, data ,{headers});
    return response?.data;
  } catch (error) {
    return error;
  }
}

export async function post(path, reqData,contentType='json') {
  try {
    let headers = {};
    headers['Content-Type'] = 'application/json';
    if (contentType != 'json') {      
      headers['Content-Type'] = 'multipart/form-data'; // FormData automatically sets this
    } 
    const response = await apiClient.post(path, reqData,{ headers });
    return response;

  } catch (error) {
    return error;
  }

}


export async function del(path) {
  try {
    const response = await apiClient.delete(path);
    return response.data;
  } catch (error) {
    return error;
  }
}